import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../services/auth-service.service';

/**
 * Guard síncrono: usa apenas `authenticated` e claims do token em memória (sem loadUserProfile em rede).
 */
export const permissionGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const keycloakService = inject(KeycloakService);
  const router = inject(Router);
  const kc = keycloakService.getKeycloakInstance();

  if (!kc.authenticated) {
    return false;
  }

  if (!authService.user()) {
    authService.hydrateUserFromTokenSync();
  }

  if (authService.hasMileExpressAccess()) {
    return true;
  }

  void router.navigate(['/forbidden']);
  return false;
};
